export let CustomEventTypes = {
  MouseDownEvent: "event@mousedown",
  MouseDragEvent: "event@mouseDrag",
  MouseUpEvent: "event@mouseUp",
  MouseMoveEvent: "event@mouseMove",
  MouseCtrlClick: "event@clickclick",
  DeselectPolygonEvent: "event@polygonDeselect",
  OnColorEvent: "event@onColorChange"
};
